import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { patternFilterSchema } from '@main/shared/utils';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { IamService } from '../../service';

export type MfaEnabledAllUsersConfig = typeof MfaEnabledAllUsersConfig._.Config;

export const MfaEnabledAllUsersConfig = IntegrationConfig.make({
  service: IamService,
  name: Integration_Handler_Names_Enum.MfaEnabledAllUsers,
  configSchema: z.object({
    userNamePatternFilter: patternFilterSchema.optional(),
  }),
});
